"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var Saved = function Saved() {
  return _react["default"].createElement("g", null, _react["default"].createElement("path", {
    d: "M244.1,445L90.9,297.1c-2-1.7-56-51.1-56-110c0-71.9,44-114.9,117.4-114.9c43,0,83.2,33.9,102.6,53c19.4-19.2,59.7-53,102.6-53c73.4,0,117.4,43,117.4,114.9c0,58.9-54,108.3-56.2,110.5L265.7,445c-2.9,2.9-6.9,4.4-10.8,4.4S247.1,447.9,244.1,445z"
  }));
};

Saved.displayName = 'Saved';
var _default = Saved;
exports["default"] = _default;
Saved.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Saved"
};

if (typeof STORYBOOK_REACT_CLASSES !== "undefined") {
  STORYBOOK_REACT_CLASSES["src/Saved.js"] = {
    name: "Saved",
    docgenInfo: Saved.__docgenInfo,
    path: "src/Saved.js"
  };
}